import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What services does Miranda Landa Services LLC provide?",
      answer: "We provide business capital consulting and strategic funding advisory services. This includes funding preparation assistance, financial documentation support, lender matching guidance, funding feasibility reviews, and business growth strategy planning."
    },
    {
      question: "Are you a lender?",
      answer: "No, we are NOT a lender. Miranda Landa Services LLC is a consulting firm that provides advisory services only. We do not issue loans, make lending decisions, or guarantee funding approval. All financing is provided by third-party financial institutions we connect you with."
    },
    {
      question: "How much do your services cost?",
      answer: "Our consultation fees vary based on the scope of services needed. We offer a free initial consultation to discuss your needs and provide transparent pricing. Contact us at info@mirandaconnects.com for more information."
    },
    {
      question: "Do you guarantee funding approval?",
      answer: "No, we do not guarantee funding approval. Approval decisions, loan terms, and all lending conditions are determined solely by the financial institutions we connect you with. Our role is to prepare you and guide you through the process."
    },
    {
      question: "How long does the consultation process take?",
      answer: "The timeline varies based on your specific needs and the complexity of your funding requirements. Typically, initial consultations take 1-2 weeks, with ongoing support as needed throughout your funding journey."
    },
    {
      question: "What types of businesses do you work with?",
      answer: "We work with businesses of all sizes and industries seeking capital for growth, expansion, equipment, working capital, or other business needs. Whether you're a startup or established business, we can help assess your funding readiness."
    },
    {
      question: "How do I opt out of SMS messages?",
      answer: "You can opt out of SMS messages at any time by replying STOP to any message you receive from us. You can also email sms@mirandaconnects.com to manage your communication preferences."
    },
    {
      question: "Is my information secure?",
      answer: "Yes, we take data security seriously. Your information is encrypted and stored securely. We only share your information with verified financial institutions for consultation purposes. See our Privacy Policy for full details."
    },
    {
      question: "What documents do I need to prepare?",
      answer: "Common documents include business financial statements, tax returns, business plans, and identification. We'll provide a customized checklist based on your specific situation during the consultation process."
    },
    {
      question: "How do I get started?",
      answer: "Simply fill out our contact form or email us at info@mirandaconnects.com. We'll schedule a free initial consultation to discuss your business goals and funding needs."
    }
  ];

  return (
    <>
      <Helmet>
        <title>FAQ - Frequently Asked Questions | Miranda Landa Services LLC</title>
        <meta name="description" content="Find answers to common questions about our business capital consulting services, funding preparation, and consultation process." />
      </Helmet>

      <section style={{
        background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
        color: 'white',
        padding: '4rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{maxWidth: '800px', margin: '0 auto'}}>
          <h1 style={{fontSize: '2.5rem', fontWeight: '800', marginBottom: '1rem'}}>
            Frequently Asked Questions
          </h1>
          <p style={{fontSize: '1.1rem', opacity: 0.95}}>
            Get answers to common questions about our services
          </p>
        </div>
      </section>

      <section style={{padding: '4rem 2rem', background: 'white'}}>
        <div style={{maxWidth: '900px', margin: '0 auto'}}>
          {faqs.map((faq, index) => (
            <div key={index} style={{
              marginBottom: '1rem',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              overflow: 'hidden'
            }}>
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                style={{
                  width: '100%',
                  padding: '1.5rem',
                  background: openIndex === index ? '#f0fdf4' : 'white',
                  border: 'none',
                  textAlign: 'left',
                  cursor: 'pointer',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  fontSize: '1.1rem',
                  fontWeight: '600',
                  color: '#064e3b'
                }}
              >
                <span>{faq.question}</span>
                <span style={{fontSize: '1.5rem', color: '#059669'}}>
                  {openIndex === index ? '−' : '+'}
                </span>
              </button>
              {openIndex === index && (
                <div style={{
                  padding: '1.5rem',
                  background: '#f9fafb',
                  borderTop: '1px solid #e5e7eb'
                }}>
                  <p style={{color: '#4b5563', lineHeight: '1.7', margin: 0}}>
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div style={{maxWidth: '900px', margin: '3rem auto 0', textAlign: 'center'}}>
          <div style={{
            background: '#f0fdf4',
            padding: '2rem',
            borderRadius: '12px',
            borderLeft: '4px solid #10b981'
          }}>
            <h3 style={{fontSize: '1.5rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              Still Have Questions?
            </h3>
            <p style={{color: '#065f46', marginBottom: '1.5rem'}}>
              We're here to help! Contact us for personalized assistance.
            </p>
            <Link to="/contact" style={{
              background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1.1rem',
              display: 'inline-block'
            }}>
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default FAQ;
